<template>
  <div class="bar bar--fixed">
    <div class="zy_constr">
      <span v-if="isHomePage" class="bar-menu" :class="{ active: showMenu }" @click="toggleMenu"></span>
      <a v-else class="bar-menu__back" href="/">返回主页</a>

      <a class="bar-icon" href="/"></a>

      <div class="bar-dropdown" @click="handleJoin">
        <div class="bar-dropdown__title">加入掌阅</div>
      </div>

      <div class="bar-nav" v-if="showMenu">
        <template v-for="anchor in anchorList">
          <a
            v-if="anchor.nav"
            :key="anchor.id"
            class="bar-nav__item"
            @click="toAnchor(anchor)"
            :class="{ 'bar-nav__item--active': activeAnchor === anchor.id }"
            >{{ anchor.name }}</a
          >
        </template>
      </div>
    </div>
    <div class="bar-mask" @click="clickMask" v-if="showMask"></div>

    <div class="bar-dropdown__list" v-if="showJoinMenu">
      <div class="bar-dropdown__wrapper">
        <a target="_blank" href="https://q7w8vltyes.jobs.feishu.cn/zhangyue" class="bar-dropdown__item">社会招聘</a>
        <a target="_blank" href="https://q7w8vltyes.jobs.feishu.cn/2024" class="bar-dropdown__item">校园招聘</a>
      </div>
    </div>
  </div>
</template>

<script>
import { NAV } from '@/config';
import { scrollTo } from '@/utils/scroll-to';
import { throttle } from '@/utils/utils';

export default {
  name: 'Bar',
  data: function () {
    return {
      showJoinMenu: false,
      showMenu: false,
      anchorList: NAV, // 导航列表
      offSet: 0, // 锚点位置相对于原位置的偏移量
      fixedHeader: true, // 是否存在固定页头
      headerHeight: 80, // 页头高度
      activeAnchor: this.$route.query.id, // 当前定位的锚点
      scrollTop: 0,

      contactArr: ['Terms', 'Copyright', 'Privacy'],
      // 可扩展的配置选项
      config: {
        scrollThrottle: 150, // 滚动节流时间
        bottomThreshold: 50, // 底部阈值（px）
        topThreshold: 10, // 顶部阈值（px）
        scrollDuration: 800 // 滚动动画时长
      }
    };
  },
  mounted: function () {
    this.initPosition();
    // 如果有路由参数，优先使用路由参数
    if (this.$route.query.id) {
      this.activeAnchor = this.$route.query.id;
    }
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.onScroll, true);
  },
  methods: {
    /**
     * 初始化导航定位
     */
    initPosition() {
      if (this.anchorList.length === 0) {
        return;
      }

      // 添加滚动监听
      window.addEventListener('scroll', throttle(this.onScroll, this.config.scrollThrottle, { trailing: true }), true);

      // 延迟执行初始定位，确保DOM已经渲染完成
      this.$nextTick(() => {
        this.updateActiveAnchor();
      });
    },
    /**
     * 滚动事件处理
     */
    onScroll() {
      if (this.anchorList.length === 0 || this.$route.name !== 'Home') {
        return;
      }

      // 更新滚动位置
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      // 更新当前激活的锚点
      this.updateActiveAnchor();
    },

    /**
     * 更新当前激活的锚点
     */
    updateActiveAnchor() {
      const scrollTop = Math.ceil(this.scrollTop);
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 获取所有锚点位置信息
      const anchorPositions = this.getAnchorPositions();

      if (anchorPositions.length === 0) {
        return;
      }

      // 判断是否滚动到底部（距离底部阈值内）
      const isAtBottom = scrollTop + windowHeight >= scrollHeight - this.config.bottomThreshold;

      let newActiveAnchor = null;

      if (isAtBottom) {
        // 滚动到底部时，激活最后一个锚点
        newActiveAnchor = anchorPositions[anchorPositions.length - 1].id;
      } else {
        // 找到当前滚动位置对应的锚点
        newActiveAnchor = this.findActiveAnchorByScrollPosition(scrollTop, anchorPositions);
      }

      // 只有当新的锚点与当前锚点不同时才更新
      if (newActiveAnchor && newActiveAnchor !== this.activeAnchor) {
        this.activeAnchor = newActiveAnchor;
      }
    },

    /**
     * 获取所有锚点的位置信息
     * @returns {Array} 锚点位置数组
     */
    getAnchorPositions() {
      const positions = [];

      this.anchorList.forEach(anchor => {
        const element = document.querySelector('#' + anchor.id);
        if (element) {
          positions.push({
            id: anchor.id,
            position: element.offsetTop + (this.fixedHeader ? -this.headerHeight : this.headerHeight)
          });
        }
      });

      // 按位置排序
      return positions.sort((a, b) => a.position - b.position);
    },

    /**
     * 根据滚动位置找到对应的激活锚点
     * @param {number} scrollTop 当前滚动位置
     * @param {Array} anchorPositions 锚点位置数组
     * @returns {string|null} 激活的锚点ID
     */
    findActiveAnchorByScrollPosition(scrollTop, anchorPositions) {
      for (let i = 0; i < anchorPositions.length; i++) {
        const currentPosition = anchorPositions[i].position;
        const nextPosition = i < anchorPositions.length - 1 ? anchorPositions[i + 1].position : Infinity;

        // 如果滚动位置在当前锚点和下一个锚点之间
        if (scrollTop >= currentPosition && scrollTop < nextPosition) {
          return anchorPositions[i].id;
        }
      }

      // 如果没有找到匹配的区间，返回最后一个锚点
      return '';
    },
    /**
     * 点击锚点导航
     * @param {Object} anchor 锚点对象
     */
    toAnchor(anchor) {
      // 执行锚点的点击事件（如果有）
      if (anchor.clickEvent && !anchor.clickEvent()) {
        return;
      }

      // 更新路由
      this.$router.push({ path: '/home', query: { id: anchor.id } });

      // 更新激活状态
      this.activeAnchor = anchor.id;
      // 滚动到目标位置
      // this.scrollToAnchor(anchor.id);
      this.hideMenu();
    },

    /**
     * 滚动到指定锚点
     * @param {string} anchorId 锚点ID
     */
    scrollToAnchor(anchorId) {
      const targetElement = document.querySelector('#' + anchorId);
      if (!targetElement) {
        return;
      }

      const headerHeight = this.fixedHeader ? -this.headerHeight : this.headerHeight;
      const scrollTop = targetElement.offsetTop + this.offSet + headerHeight;

      // 如果已经在目标位置，不需要滚动
      if (scrollTop === document.documentElement.scrollTop) {
        return;
      }

      // 执行滚动
      scrollTo(scrollTop, this.config.scrollDuration);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    hideMenu() {
      this.showMenu = false;
      this.showJoinMenu = false;
    },
    // 点击弹层
    clickMask(e) {
      e.stopPropagation();
      this.hideMenu();
    },
    handleJoin() {
      this.showJoinMenu = !this.showJoinMenu;
    }
  },
  computed: {
    /**
     * 判断是否在主页
     * @returns {boolean} 是否在主页
     */
    isHomePage() {
      return this.$route.name === 'Home';
    },
    showMask() {
      return this.showMenu || this.showJoinMenu;
    }
  },
  watch: {
    /**
     * 监听路由变化，处理从二级页面回来的定位
     */
    $route(to) {
      // 处理隐私政策等页面的特殊逻辑
      // if (this.contactArr.indexOf(this.$route.name) > -1) {
      //   this.activeAnchor = 'contact';
      //   return;
      // }

      // // 非首页不处理
      // if (this.$route.name !== 'Home') {
      //   return;
      // }

      // 从二级页面回来时，根据路由参数定位
      if (to.query.id) {
        this.activeAnchor = to.query.id;
        this.scrollToAnchor(to.query.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.bar {
  height: rem(120);
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: #fff;
}

.bar-icon {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: rem(198);
  height: rem(48);
  position: absolute;
  background: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/48eae6dc-b46b-4dff-a937-de14b2b691b0.png');
  background-size: cover;
}

.bar-menu {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: rem(48);
  width: rem(48);
  height: rem(48);
  background-image: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/eae023cd-7df3-426e-a5d7-075e9a633916.png');
  background-size: cover;
  &__back {
    display: inline-block;
    color: rgba(0, 0, 0, 0.55);
    font-size: rem(36);
    line-height: rem(48);
    margin: rem(42) 0 0 rem(48);
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // left: rem(48);
    // width: rem(48);
  }
}

.bar-nav {
  position: absolute;
  z-index: 10;
  top: rem(120);
  left: 0;
  width: 100%;
  background-color: #fff;
  padding: 0 rem(30);
  box-sizing: border-box;
}

.bar-nav__item {
  display: block;
  height: rem(150);
  line-height: rem(150);
  font-size: rem(42);
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  border-bottom: rem(1) solid rgba(0, 0, 0, 0.1);
  &:last-child {
    border-bottom: none;
  }
  &--active {
    color: #1680fc;
  }
}

.bar-dropdown {
  position: absolute;
  top: 50%;
  right: rem(60);
  transform: translateY(-50%);
}

// 加入按钮样式
.bar-dropdown__title {
  height: rem(52);
  line-height: rem(52);
  font-size: rem(36);
  color: rgba(0, 0, 0, 0.55);
  padding-left: rem(52);
  background: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/410fa659-7095-4b01-80ed-e6e416ad3a51.png')
    no-repeat center left;
  background-size: rem(42);
}

.bar-dropdown__list {
  position: absolute;
  box-sizing: border-box;
  padding: rem(24) 0;
  top: rem(168);
  right: rem(48);
  width: rem(300);
  background: #fff;
  display: block;
  z-index: 200;
  border-radius: rem(12);

  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-left: rem(18) solid transparent;
    border-right: rem(18) solid transparent;
    border-bottom: rem(18) solid #fff;
    position: absolute;
    top: rem(-12);
    right: rem(30);
  }

  .bar-dropdown__item {
    display: block;
    height: rem(144);
    text-align: center;
    line-height: rem(144);
    color: rgba(0, 0, 0, 0.85);
    font-size: rem(36);
  }
}

// 遮罩层样式
.bar-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: rem(120);
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
